<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate>
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                Course Schedule
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            List Of Course Schedule
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-3" [formGroup]="CourseScheduleSearchForm">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>Search
                                                    </mat-label> <input class="color" matInput placeholder="Search"
                                                        (keyup)="keypress()" formControlName="SearchString">
                                                    <mat-icon matSuffix>search</mat-icon>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-1 prpl">
                                                <button id="addBtn" type="button"
                                                    class="btn btn-primary btn-icon-text  mt-1"
                                                    (click)="addnewrecord()">
                                                    <span style="display: flex; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/plus.gif"
                                                            style="margin-right: 5px;">
                                                        New
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row clearfix">
                                            <div class="table-responsive table-container">
                                                <table appShortTable id="datatable" class="table table-bordered text-nowrap">
                                                    <thead>
                                                        <tr>
                                                            <th class="f600">
                                                                {{'header.course-schedule.table.CoSchCode' | translate}}
                                                            </th>
                                                            <th class="f600">
                                                                {{'header.course-schedule.table.CoSchCoName' |
                                                                translate}}
                                                            </th>
                                                            <!-- <th class="f600">
                                                                {{'header.course-schedule.table.CoSchImagePath' |
                                                                translate}}
                                                            </th> -->
                                                            <th width="10%" class="f600 text-center">
                                                                {{'header.course-schedule.table.Action' | translate}}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data">
                                                        <tr *ngFor="let course of coursecheduleList;">
                                                            <td>{{course.CoCode}} </td>
                                                            <td>{{course.CoName}}</td>
                                                            <!-- <td>{{course.CShPath}} </td> -->
                                                            <td class="text-center">

                                                                <a class="btn-floating" title="Edit">
                                                                    <i class="fa fa-edit"
                                                                        (click)="editData(course)"></i>
                                                                </a>
                                                                <a class="btn-floating" title="Delete">
                                                                    <i class="fas fa-trash"
                                                                        (click)="deleteData(course)"></i>
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                                            (page)="onPageChange($event)"></mat-paginator>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>